import React from "react";
import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import { NearbyPatientsPin } from "./NearbyPatientsPin";
import { CLINICIAN_ROLES, INearbyPatient } from "@home-health-notify/domain";
import { NearbyPatientPinContent } from "./NearbyPatientPinContent";

type MarkerWithInfoWindowProps = {
  position: google.maps.LatLngLiteral;
  patients: INearbyPatient[];
  showInfoWindow: () => void;
  closeInfoWindow: () => void;
  isActive?: boolean;
  selectedDiscipline?: CLINICIAN_ROLES;
};

const MarkerWithInfoWindow = ({
  position,
  patients,
  showInfoWindow,
  closeInfoWindow,
  isActive,
  selectedDiscipline,
}: MarkerWithInfoWindowProps) => {
  const [markerRef, marker] = useAdvancedMarkerRef();

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={position}
        onClick={showInfoWindow}
      >
        <NearbyPatientsPin patients={patients} />
      </AdvancedMarker>
      {isActive && (
        <InfoWindow
          anchor={marker}
          position={position}
          onClose={closeInfoWindow}
        >
          <NearbyPatientPinContent
            selectedDiscipline={selectedDiscipline}
            patients={patients}
          />
        </InfoWindow>
      )}
    </>
  );
};

export { MarkerWithInfoWindow };
